export default __webpack_public_path__ + "static/media/birthday.5bc5cc0f.png";